
import settings from './de.settings';
import sidebars from './de.sidebars';
import chat from './de.chat';
import myProfile from './de.myProfile';    
import ad from './de.ad';
import termsOfUse from './de.termsOfUse';
import privacyPolicy from './de.privacyPolicy';
import home from './de.home';
import help from './de.help';
import countries from './de.countries'
import faq from './de.faq';
import advertisementGuide from './de.advertisementGuide';


import accountSupport from './de.accountSupport';
import platformGuide from './de.platformGuide';

const de = {
  // 🔒 ForgotPassword.tsx
 enterYourEmail: "E-Mail eingeben",
sendResetLink: "Link zum Zurücksetzen des Passworts senden",
pleaseEnterEmail: "❌ Bitte gib deine E-Mail-Adresse ein.",
couldNotSendResetEmail: "❌ Die E-Mail zum Zurücksetzen des Passworts konnte nicht gesendet werden. Bitte versuche es erneut.",

// 🌟 Startseite / Anmeldung
slogan: "Lasst die Party beginnen",

email: "E-Mail",
password: "Passwort",
login: "Anmelden",
loginElnydo: "Log in",
createAccount: "Neues Konto erstellen",
forgotPassword: "Passwort vergessen?",
legalNoticeforgotpassword: "Mit dem Fortfahren stimmst du unseren Richtlinien zu.",

startPage: {
  loginSuccess: "✅ Anmeldung erfolgreich!",
  invalidCredentials: "❌ Ungültige Anmeldedaten!",
  privacyTerms: "Datenschutz & Nutzungsbedingungen",
  legalNoticelogin: "Mit der Anmeldung stimmst du unseren Richtlinien zu.",
  loginTitlelogin: "Melde dich an",
  loginTitlehappening: "und entdecke, was um dich herum passiert.",
},

twoFA: {
  title: "Gib den 6-stelligen Code ein",
  intro: "Wir haben dir einen Bestätigungscode für die Anmeldung per E-Mail gesendet.",
  placeholder: "••••••",
  cancel: "Abbrechen",
  verify: "Bestätigen & Weiter",
  verifying: "Wird überprüft…",
  hint: "Keinen Code erhalten? Es kann bis zu einer Minute dauern. Bitte prüfe auch deinen Spam-Ordner.",
  missingToken: "2FA-Token fehlt",
  invalidCode: "Bitte gib den 6-stelligen Code ein, den wir dir gesendet haben.",
  verifyFailed: "Überprüfung fehlgeschlagen.",
  requestFailed: "Der Bestätigungscode konnte nicht gesendet werden.",
},

// 👤 Profilerstellung / Registrierung
profileSetup: {
  title: "Erstelle dein Konto",
  profileName: "Profilname",
  email: "E-Mail",
  emailplace: "name@beispiel.de",
  password: "Passwort",
  createpassword: "Erstelle ein Passwort (mindestens 8 Zeichen und mindestens 1 Zahl)",
  over18: "Ich bestätige, dass ich mindestens 18 Jahre alt bin",
  createProfile: "Konto erstellen",
  alreadyAccount: "Du hast bereits ein Konto? Jetzt anmelden",
  legalNotice: "Mit der Erstellung eines Kontos stimmst du unseren Richtlinien zu.",
  privacyPolicy: "Datenschutzerklärung",
  termsOfUse: "Nutzungsbedingungen",
},

// 🔁 Passwort zurücksetzen
resetPassword: {
  title: "Passwort zurücksetzen",
  newPassword: "Neues Passwort",
  confirmNewPassword: "Neues Passwort bestätigen",
  resetting: "Wird zurückgesetzt...",
  resetButton: "Passwort zurücksetzen",
  passwordsMismatch: "Die Passwörter stimmen nicht überein!",
  resetError: "❌ Fehler beim Zurücksetzen des Passworts.",
  success: "✅ Passwort erfolgreich zurückgesetzt! Du wirst jetzt angemeldet...",
},

// ✉️ E-Mail bestätigen (E-Mail-Inhalt + Bildschirmtext)
confirmEmail: {
  title: "Überprüfe deine E-Mails zur Bestätigung",
  subtitle: "Wir haben eine Bestätigungs-E-Mail gesendet an:",
  note: "Bitte überprüfe deinen Posteingang und den Spam-Ordner.",
  returnButton: "Zurück zur Anmeldung",
  heading: "Willkommen bei Elnydo 🎉",
  intro: "Klicke auf die Schaltfläche unten, um deine E-Mail-Adresse zu bestätigen und dein Profil zu aktivieren:",
  button: "E-Mail bestätigen",
  footer1: "Dieser Link ist aus Sicherheitsgründen 24 Stunden gültig.",
  footer2: "Falls du dieses Konto nicht erstellt hast, kannst du diese Nachricht einfach ignorieren.",
  footer3: "Diese E-Mail wurde von Elnydo an dich gesendet.",
},

// 📩 Bildschirm „E-Mail überprüfen“
checkEmail: {
  title: "Bestätige deine E-Mail-Adresse",
  subtitle: "Wir haben einen Bestätigungslink gesendet an:",
  note: "Bitte überprüfe deinen Posteingang (und Spam-Ordner), um die Registrierung abzuschließen.",
  returnButton: "Zurück zur Anmeldung",
},

// 📤 Bildschirm „Link zum Zurücksetzen gesendet“
emailSentTitle: "Überprüfe deine E-Mails",
emailSentSubtitle: "Wir haben einen Link zum Zurücksetzen des Passworts gesendet an:",
emailSentNote: "Bitte überprüfe deinen Posteingang (und Spam-Ordner).",
emailSentReturnButton: "Zurück zur Startseite",

// 🌐 Sprache
language: "Sprache",

common: {
  back: "Zurück",
  continue: "Weiter",
  close: "Schließen",
  cancel: "Abbrechen",
  yes: "Ja",
  no: "Nein",
  confirm: "Bestätigen",
  ok: "OK",
  saving: "Speichern...",
},

/////////////////////////////////////////////////////////////
// GalleryPosting
/////////////////////////////////////////////////////////////

galleryPosting: {
  overlay: {
    uploading: "Wird hochgeladen",
  },

  alerts: {
    videosSkippedInvalidDuration: "Einige Videos wurden übersprungen, da sie zwischen 2,9 und 183 Sekunden lang sein müssen.",
    onlyOneVideoAllowed: "Pro Beitrag ist nur ein Video erlaubt.",
    videoMustBeFirst: "Das Video muss das erste Medienelement sein.",
    mediaPerPostLimit: "Du kannst bis zu 8 Medien pro Beitrag hinzufügen. Entferne zuerst etwas, bevor du weitere Dateien hinzufügst.",
    mediaPerPostHardLimit: "Ein Beitrag kann maximal 8 Medien enthalten.",
    videosSkippedTooLongShort: "Video(s), die länger als 3 Minuten und 3 Sekunden sind, wurden übersprungen.",
    videosSkippedTooLongSummary: "Einige Videos wurden übersprungen, weil sie länger als 3 Minuten und 3 Sekunden sind.",
    filesSkippedByCapSummary: "Einige Dateien wurden übersprungen, da das Limit von 8 Medien pro Beitrag erreicht wurde.",
    loginRequired: "Du musst angemeldet sein.",
    hashtagLimit: "Du kannst bis zu {{max}} Hashtags hinzufügen.",
    postTooLargeClient: "Dieser Beitrag ist zu groß ({{actualGb}} GB). Die maximal zulässige Größe pro Beitrag beträgt etwa {{maxGb}} GB.\n\nBitte entferne einige Videos oder kürze sie, bevor du den Beitrag veröffentlichst.",
    postTooLargeServer: "Dein Beitrag ist zu groß. Die maximale Gesamtgröße der Medien pro Beitrag beträgt etwa {{maxGb}} GB.\n\nBitte entferne einige Medien oder kürze deine Videos.",
    dailyPostLimitReached: "Du hast dein tägliches Beitragslimit erreicht. Bitte versuche es morgen erneut.",
    vpnBlockedFallback: "Das Hochladen von Medien ist bei Verwendung eines VPNs oder Proxys nicht erlaubt. Bitte deaktiviere diesen und versuche es erneut.",
    postFailed: "Das Veröffentlichen der Medien ist fehlgeschlagen.",
    discardConfirm: "Möchtest du die Änderungen wirklich verwerfen?",
  },

  banner: {
    vpnBlocked: "Das Hochladen von Medien ist bei Verwendung eines VPNs oder Proxys nicht erlaubt. Bitte deaktiviere diesen und versuche es erneut.",
  },

  buttons: {
    delete: "Löschen",
    filter: "🎛️ Filter",
    music: "🎵 Musik",
    changeMusic: "🎵 Musik ändern",
    addMusic: "Musik hinzufügen",
  },

  fallback: {
    noPreview: "Keine Vorschau verfügbar",
    anonymous: "Anonym",
  },

  addMedia: {
    title: "Hier klicken, um Bilder & Videos auszuwählen",
    subtitle: "…oder hierher ziehen",
  },

  addButtons: {
    add: "Hinzufügen",
    change: "Ändern",
    filter: "Filter",
  },
},

/////////////////////////////////////////////////////////////
// Gallery
/////////////////////////////////////////////////////////////

gallery: {
  noPostsForFilter: "Für den ausgewählten Filter sind keine Beiträge verfügbar.",
  unknownUser: "Unbekannter Benutzer",
  unknownLocation: "Unbekannt",

  post: {
    unknownUser: "Unbekannter Benutzer",
    noMedia: "Keine Medien verfügbar",
    postedAt: "veröffentlicht am {{date}}",
    presentationButton: "Präsentation",
  },

  edit: {
    missingPostId: "Beitrags-ID fehlt",
    saveFailed: "Änderungen konnten nicht gespeichert werden.",
    discardConfirm: "Alle Änderungen verwerfen?",
    saving: "Wird gespeichert",
    anonymous: "Anonym",
    noPreview: "Keine Vorschau verfügbar",
    delete: "Löschen",
    title: "Beitrag bearbeiten",
    confirmSaveTitle: "Änderungen an diesem Beitrag speichern?",
    confirmSaveSubtitle: "Dadurch wird dein aktueller Beitrag überschrieben.",
    updatedTitle: "Beitrag aktualisiert",
    updatedMessage: "Dein Beitrag wurde erfolgreich aktualisiert.",
  },

  media: {
    previewAlt: "Vorschau",
  },

  addMusic: {
    back: "Zurück",
    heading: "🎵 Musik auswählen",
    searchPlaceholder: "Nach Titel oder Künstler suchen…",
    clear: "Löschen",
    noMatches: "Keine Titel entsprechen „{{query}}“.",
    openDetails: "Details zu {{title}} öffnen",
    choose: "Auswählen",
    chooseTitle: "Diesen Titel auswählen",
    noVideo: "Kein Video ausgewählt",
    unknownTrack: "Titel",
  },

  report: {
    failed: "Beitrag konnte nicht gemeldet werden",
    button: "Beitrag melden",
    title: "Diesen Beitrag melden",
    detailsPlaceholder: "(Optional) Beschreibe das Problem...",
    submit: "Meldung absenden",
    submitted: "Meldung gesendet",
    reasons: {
      spam: "Spam",
      hate: "Hassrede",
      harassment: "Belästigung oder Mobbing",
      sexualContent: "Sexuelle Inhalte",
      scamOrFraud: "Betrug oder Täuschung",
      violence: "Gewalt",
      selfHarm: "Selbstverletzung",
      other: "Sonstiges",
    },
  },

  ad: {
    learnMore: "Mehr erfahren",
    sponsored: "Gesponsert",
  },
},


/////////////////////////////////////////////////////////////
// Gallery.Choose Track
/////////////////////////////////////////////////////////////

chooseTrack: {
  selectTrack: "Titel auswählen.",
  noVideoSource:
    "Keine HTTP-Videoquelle und keine Datei verfügbar. Öffne den Dialog erneut über „Musik hinzufügen“, damit sich die Videodatei im Speicher befindet, oder gib eine Server-URL an.",
  previewFailed: "Vorschau fehlgeschlagen. Siehe Konsole für Details.",
  generatePreviewFirst: "Erstelle zuerst eine Vorschau.",
  saveFailed: "Speichern fehlgeschlagen. Siehe Konsole für Details.",

  trimMusicTitle: "Musik zuschneiden",
  unknownArtist: "Unbekannter Künstler",
  trackPreview: "Titelvorschau",

  play: "Abspielen",
  pause: "Pause",

  mergeCta: "Musik & Video zusammenführen",
  saveCta: "Speichern & Weiter",

  processing: "Wird auf dem Server verarbeitet…",
  noVideo: "Kein Video ausgewählt",
},


/////////////////////////////////////////////////////////////

videoFilter: {
  sidebar: {
    title: "Filter",
  },
  buttons: {
    reset: "Zurücksetzen",
    save: "Speichern",
    back: "Zurück",
    processing: "Wird verarbeitet…",
  },
  messages: {
    noMedia: "Keine Medien zum Bearbeiten gefunden.",
    noSource: "Keine Videoquelle…",
    processFailed: "Video konnte nicht verarbeitet werden. Siehe Konsole für Details.",
  },
  preview: {
    placeholderAria: "Video-Platzhalter",
  },
  controls: {
    muted: "Stumm",
    autoplay: "Automatische Wiedergabe",
  },
},

/////////////////////////////////////////////////////////////
// Location Change
/////////////////////////////////////////////////////////////

locationChange: {
  unknown: "Unbekannt",
  title: "Standort ändern",
  sidebar: {
    title: "Standort ändern",
  },
  search: {
    placeholder: "Nach einer Stadt oder einem Land suchen…",
    clearAria: "Suche löschen",
    searching: "Suche läuft…",
    noResults: "Keine Ergebnisse",
    ariaSuggestions: "Standortvorschläge",
  },
  badge: {
    country: "Land",
    state: "Bundesland/Region",
    city: "Stadt",
    village: "Dorf",
    suburb: "Stadtteil",
    place: "Ort",
    popular: "Beliebt",
  },
  popular: {
    title: "Schnellvorschläge",
  },

  actions: {
    useCurrentLocation: "Aktuellen Standort verwenden",
    confirm: "Standort bestätigen",
    closeAria: "Schließen",
  },

  labels: {
    selected: "{{city}}, {{country}}",
    selectedLabel: "Ausgewählt",
  },
},

confirmLocation: {
  title: "Standort bestätigen",
  loading: "Karte und Standortdaten werden geladen...",
  locationKnown: "{{city}} ({{country}})",
  locationUnknown: "Standort unbekannt",
  captionPlaceholder: "Beschriftung schreiben (optional)…",
  buttons: {
    confirmAndPost: "Standort bestätigen & Beitrag veröffentlichen",
    posting: "Wird veröffentlicht…",
  },
  alerts: {
    missingMediaOrLocation: "Medien oder Standort fehlen. Bitte überprüfe deine Angaben und versuche es erneut.",
    loginRequired: "Du musst angemeldet sein.",
    postSuccess: "Dein Beitrag wurde erfolgreich veröffentlicht!",
    postFailed: "Veröffentlichen fehlgeschlagen. Bitte versuche es erneut.",
  },
},

//MediaPresentationMode
mediaPresentation: {
  loading: "Wird geladen...",
  empty: "Keine Medien zum Anzeigen.",
},

//Edit Media
editMedia: {
  title: "Medien bearbeiten",
  noItem: "Kein Medium zum Bearbeiten ausgewählt.",
  save: "Speichern",
  alt: "Medien bearbeiten",
},

//MediaPreviewMode
mediaPreview: {
  empty: "Keine Vorschaumedien gefunden.",
  viewer: {
    closeLabel: "Vorschau schließen",
    closeTitle: "Schließen",
    prevLabel: "Vorheriges",
    prevTitle: "Vorheriges",
    nextLabel: "Nächstes",
    nextTitle: "Nächstes",
  },
},

//MediaViewerOverlay
mediaViewer: {
  closeLabel: "Schließen",
  prevLabel: "Vorheriges",
  nextLabel: "Nächstes",
},

imageFilter: {
  sidebar: {
    title: "Filter",
  },
  buttons: {
    reset: "Zurücksetzen",
    save: "Speichern",
    back: "Zurück",
  },
  messages: {
    noMedia: "Keine Medien zum Bearbeiten gefunden.",
    loading: "Wird geladen…",
  },
},

posts: {
  create: {
    mediaReady: "Medien angehängt und bereit zum Speichern.",
    save: "Speichern",
  },
},

//MusicDetailPage
musicDetail: {
  loading: "Wird geladen…",
  notFound: "Titel nicht gefunden.",
  loadError: "Titeldetails konnten nicht geladen werden.",
  back: "Zurück",
  close: "Schließen",
  unknownArtist: "Unbekannter Künstler",
  coverAlt: "Cover",

  usedIn_one: "Verwendet in {{count}} Beitrag",
  usedIn_other: "Verwendet in {{count}} Beiträgen",

  empty: "Für diesen Titel wurden noch keine Videos oder Bilder gefunden.",

  openPostTitle: "Beitrag öffnen",
  openPostLabel: "Öffnen →",
},

//LocationCollection
locationCollection: {
  title: "Beiträge zu diesem Standort",
  unknownCity: "Unbekannte Stadt",
  unknownCountry: "Unbekanntes Land",
  empty: "Für diesen Standort wurden noch keine Beiträge gefunden.",
  loadError: "Standortbeiträge konnten nicht geladen werden.",
  openPostLabel: "Öffnen →",
  posts_one: "{{count}} Beitrag",
  posts_other: "{{count}} Beiträge",
},

//PresentationPreview
presentationPreview: {
  noMedia: "Keine Vorschaumedien gefunden.",
  closeViewer: "Vorschau schließen",
  previous: "Vorheriges",
  next: "Nächstes",
},

//SmartVideoPlayer
smartVideo: {
  playWithSound: "Mit Ton abspielen",
  html5Fallback: "Dein Browser unterstützt HTML5-Videos nicht.",
},

//BlockedList
blockedList: {
  title: "Blockierte Benutzer",
  refresh: "Aktualisieren",
  refreshing: "Wird aktualisiert…",

  loading: "Wird geladen…",
  empty: "Du hast noch niemanden blockiert.",

  errorLoad: "Blockierte Benutzer konnten nicht geladen werden.",
  errorUnblock: "Entsperren fehlgeschlagen.",

  confirmUnblock: "Diesen Benutzer entsperren?",

  statusDeleted: "gelöscht",
  statusDeactivated: "deaktiviert",

  blockedSince: "Blockiert seit:",
  viewProfile: "Profil ansehen",

  unblocking: "Wird entsperrt…",
  unblock: "Entsperren",
},

// FollowButtonInline
followButton: {
  follow: "Folgen",
  unfollow: "Entfolgen",
},

//Hashtag Selector
hashtagSelector: {
  placeholder: "Versteckte Hashtags eingeben oder auswählen",
  placeholdermobile: "Versteckte Hashtags eingeben",
},

// Language Selector
languageSelector: {
  title: "Sprache auswählen",
  close: "Schließen",
},

//Lazymedia
lazymedia: {
  videoNotSupported: "Dein Browser unterstützt das Video-Tag nicht.",
},

//MediaUploader
mediaUploader: {
  uploading: "Wird hochgeladen…",
  uploadFailed: "Hochladen fehlgeschlagen",
  uploadedLabel: "Hochgeladen:",
  openFile: "Datei öffnen",
},

//FirstRunPrivacy
firstRunPrivacy: {
  title: "Lege deine Datenschutzeinstellungen fest",
  loading: "Wird geladen…",
  errorSave: "Einstellungen konnten nicht gespeichert werden.",
  yes: "Ja",
  no: "Nein",
  continue: "Weiter",
  saving: "Wird gespeichert…",
  footerNote: "Du kannst diese Einstellungen jederzeit unter Einstellungen → Daten & Datenschutz ändern.",
  toggles: {
    locationTitle: "Gerätestandort verwenden",
    locationDesc: "Verwende meinen Gerätestandort beim Markieren eines Beitrags oder beim Erkunden von Beiträgen in der Nähe.",
    analyticsTitle: "Anonyme Analysen",
    analyticsDesc: "Hilf uns, Funktionen anonym zu verbessern. Keine Werbung, kein Tracking.",
    pushTitle: "Push-Benachrichtigungen",
    pushDesc: "App-Benachrichtigungen für Nachrichten und Aktivitäten erlauben.",
  },
},

requirePrivacyChange: {
  title: "Zum Veröffentlichen muss die Standortnutzung aktiviert werden",
  close: "Schließen",
  errorSave: "Einstellungen konnten nicht gespeichert werden.",
},

requirePrivacyChangeCL: {
  title: "Um den aktuellen Standort zu verwenden, muss der Standortzugriff aktiviert werden",
  close: "Schließen",
  errorSave: "Einstellungen konnten nicht gespeichert werden.",
},

requirePrivacyChangeMap: {
  title: "Um den aktuellen Standort auf der Karte zu verwenden, muss der Standortzugriff aktiviert werden",
  close: "Schließen",
  cancel: "Abbrechen",
  errorSave: "Einstellungen konnten nicht gespeichert werden.",
},


profileActions: {
  moreActions: "Weitere Aktionen",

  postsNamed: "Beiträge von {{name}}",
  postsGeneric: "Beiträge anzeigen",
  thisUser: "diesem Benutzer",

  follow: "Folgen",
  unfollow: "Entfolgen",

  block: "Blockieren",
  unblock: "Blockierung aufheben",
  blockAndReport: "Blockieren & melden",

  blockConfirm:
    "{{name}} blockieren? Diese Person kann nicht mehr mit dir interagieren und ihr könnt die Beiträge oder Nachrichten des jeweils anderen nicht mehr sehen.",

  blocked: "Benutzer wurde blockiert.",
  unblocked: "Blockierung des Benutzers aufgehoben.",
  blockedWithInfo:
    "Benutzer wurde blockiert. Du kannst ihn später über den Meldebildschirm melden.",

  errors: {
    actionFailed: "Aktion fehlgeschlagen",
    blockFailed: "Blockieren fehlgeschlagen",
    unblockFailed: "Aufheben der Blockierung fehlgeschlagen",
  },
},

openMenu: {
  title: "Menü",
  gallery: "🖼 Galerie",
  favorite: "⭐ Mein Feed",
  myLikes: "❤️ Meine Likes",
  locationChange: "🌍 Standort ändern",
  uploadPost: "📷 Beitrag hochladen",
  notifications: "🔔 Benachrichtigungen",
  myProfile: "👻 Mein Profil",
  myPosts: "📭 Meine Beiträge",
  chat: "💬 Chat",
  settings: "⚙️ Einstellungen",
  logout: "🚪 Abmelden",
},

  //Countries
  ...countries,
  
  //Settings
  ...settings,

  //Sidebars
  ...sidebars,

  //Chat
  ...chat,

  //MyProfile
  ...myProfile,

  //Privacy Terms
  ...termsOfUse,

//Data Protection Report
  ...privacyPolicy,

  ...accountSupport,
 ...platformGuide,
...advertisementGuide,
...faq,
  //Home
  home,

  

  help,

  //Ad
  ad,


  // 🔗 Statusmeldungen für die E-Mail-Bestätigung
confirmEmailLoading: "⏳ Deine E-Mail wird bestätigt...",
confirmEmailSuccess: "🎉 Deine E-Mail wurde erfolgreich bestätigt! Du wirst weitergeleitet...",
confirmEmailError: "❌ Ungültiger oder abgelaufener Bestätigungslink.",

emailConfirmedTitle: "✅ E-Mail erfolgreich bestätigt!",
emailConfirmedRedirect: "Weiterleitung zu deinem Profil...",
emailConfirmedFailed: "❌ Bestätigung fehlgeschlagen",
emailConfirmedMissingToken: "Fehlendes oder ungültiges Bestätigungstoken.",
emailConfirmedChecking: "Bestätigungslink wird überprüft...",
} as const;

export default de;
